import React from "react"
import BaseChart from './BaseChart'

const Pie = (props)=>(
    <BaseChart type='pie' {...props} />
)

export default Pie